var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M12 8.25C10.21 8.25 8.75 9.71 8.75 11.5C8.75 13.29 10.21 14.75 12 14.75C13.79 14.75 15.25 13.29 15.25 11.5C15.25 9.71 13.79 8.25 12 8.25ZM13 11.18C13 11.79 12.67 12.37 12.15 12.68L11.38 13.14C11.26 13.21 11.13 13.25 10.99 13.25C10.74 13.25 10.49 13.12 10.35 12.89C10.14 12.53 10.25 12.07 10.61 11.86L11.37 11.4C11.45 11.35 11.49 11.27 11.49 11.19V10.26C11.49 9.85 11.83 9.51 12.24 9.51C12.65 9.51 13 9.84 13 10.25V11.18Z",
          fill: _vm.color
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M18.5408 4.16965L13.0408 2.10965C12.4708 1.89965 11.5408 1.89965 10.9708 2.10965L5.47078 4.16965C4.41078 4.56965 3.55078 5.80965 3.55078 6.93965V15.0396C3.55078 15.8496 4.08078 16.9196 4.73078 17.3996L10.2308 21.5096C11.2008 22.2396 12.7908 22.2396 13.7608 21.5096L19.2608 17.3996C19.9108 16.9096 20.4408 15.8496 20.4408 15.0396V6.93965C20.4508 5.80965 19.5908 4.56965 18.5408 4.16965ZM12.0008 16.2496C9.38078 16.2496 7.25078 14.1196 7.25078 11.4996C7.25078 8.87965 9.38078 6.74965 12.0008 6.74965C14.6208 6.74965 16.7508 8.87965 16.7508 11.4996C16.7508 14.1196 14.6208 16.2496 12.0008 16.2496Z",
          fill: _vm.color
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }